"use client";

import { useRef, useCallback } from "react";
import { useRouter } from "@rangojs/router/client";

export function SearchForm({ action, defaultValue }: { action: string; defaultValue?: string }) {
  const router = useRouter();
  const timerRef = useRef<ReturnType<typeof setTimeout>>(null);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const q = e.target.value.trim();
    if (timerRef.current) clearTimeout(timerRef.current);
    if (q.length < 2) return;
    timerRef.current = setTimeout(() => {
      router.prefetch(`${action}?q=${encodeURIComponent(q)}`);
    }, 300);
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      e.preventDefault();
      const q = new FormData(e.currentTarget).get("q") as string;
      if (q?.trim()) {
        router.push(`${action}?q=${encodeURIComponent(q.trim())}`);
      }
    },
    [action, router],
  );

  return (
    <form onSubmit={handleSubmit} className="mb-6 flex gap-2">
      <input
        type="text"
        name="q"
        defaultValue={defaultValue}
        onChange={handleChange}
        placeholder="Search products..."
        className="flex-1 rounded border border-slate-300 px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500"
      />
      <button
        type="submit"
        className="rounded bg-slate-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-slate-800"
      >
        Search
      </button>
    </form>
  );
}
